/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">{{gender}} Avatars</h4>
        <a href="#" v-if="gender == 'Man'"  @click.prevent="updategender('Woman')">
            Switch to woman avatars
        </a>
        <a href="#" v-if="gender == 'Woman'"  @click.prevent="updategender('Man')">
            Switch to man avatars
        </a>
<div class="accordion">
  <div class="card" v-for="(avatars, type) in avatars" :key="type">
    <div class="card-header">
      <h5 class="mb-0">
        <button class="btn btn-link">
          {{type}}
        </button>
      </h5>
    </div>

    <div class="collapse show">
      <div class="card-body d-flex overflow-auto">
        <div class="text-center mx-2 avatar-body" v-for="item in avatars" :key="item._id">
            <img :src="item.thumb" alt="thumb" class="img-thumbnail">
            <p>{{item._id}}</p>
            <p>price: {{item.price}}</p>
            <i class="far fa-window-close avatar-close" @click.prevent="deleteItem(item._id)"></i>
        </div>
      </div>
    </div>
  </div>

</div>
    </div>
</div>
</template>
<style scoped>
    .avatar-body {
        position: relative
    }
    .avatar-close {
        position: absolute;
        right: 20px;
        top: 10px;
        color: red;
        background-color: white;
    }
</style>
<script>
import axios from "axios"
export default {
    name: 'Avatars',
    components: {

    },
    data() {
        return {
            avatars: {},
            baseUrl: "/avatarsall",
            gender: "Man",
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.$toast.open({
            message: "Processing : Loading Levels Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }

        let genderI;

        if(this.gender == 'Man') {
            genderI = 'male';
        } else {
            genderI = 'femenino';
        }

        axios.get(this.$apiURI + this.baseUrl + '/' + genderI, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.avatars = response.data.data.avatars;
                    console.log(this.avatars);
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
        },
        deleteItem(id) {
            if(confirm('Are you sure?') == true) {

                const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }

                axios.get(this.$apiURI + '/avatars/' + id + '/delete', config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        
                        // eslint-disable-next-line no-console
                        // console.log(response.data.data.teachers)
                        this.initData();

                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
            }
        },
        updategender(gender) {
            this.gender = gender;
            this.initData();
        }
    }
}
</script>
